import React, { useEffect, useState, useRef } from "react";
import HomePageNavBar from "../Components/HomePageNavBar";
import LocationBar from "../Components/LocationBar";
import RegionColors from "../Components/RegionColors";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../Components/Footer";
import PrivacyPolicyPopup from "./PrivacyPolicyPopup";
import ListingsCard from "../Components/ListingsCard";
import ListingsFeed from "../Components/ListingsFeed";
import LoadingPage from "../Components/LoadingPage";
import { hiddenCategories } from "../Constants/hiddenCategories";
import LocationNotFoundPopUp from "../Components/LocationNotFoundPopUp";
import { getPreferredListings, getListings } from "../Services/listingsApi";
import { getCities } from "../Services/citiesApi";
import { getCategory } from "../Services/CategoryApi";
import { getCurrentUser } from "../Services/usersApi";

import CITYIMAGE from "../assets/City.png";
import CITYDEFAULTIMAGE from "../assets/CityDefault.png";
import MostPopularCategories from "../Components/MostPopularCategories";
import AllCategoriesTiles from "../Components/AllCategoriesTiles";

function ListingsPageSkeleton() {
  return (
    <>
      {/* Header Skeleton */}
      <div
        className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-10 flex justify-between items-center"
      >
        <div className="h-8 bg-gray-200 rounded w-48 animate-pulse"></div>
        <div className="h-6 w-6 bg-gray-200 rounded-full animate-pulse"></div>
      </div>

      {/* Grid Skeleton */}
      <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-0 space-y-10 flex flex-col">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
          {Array.from({ length: 8 }).map((_, index) => (
            <div
              key={index}
              className="flex flex-col space-y-4 rounded-lg border border-gray-200 p-4 animate-pulse"
            >
              <div className="w-full h-48 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Load More Button Skeleton */}
      <div className="flex justify-center my-10">
        <div className="h-10 w-40 bg-gray-200 rounded-full animate-pulse"></div>
      </div>

      {/* Discover More Section Skeleton */}
      <div
        className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-10"
      >
        <div className="h-8 bg-gray-200 rounded w-64 animate-pulse"></div>
      </div>

      {/* Discover More Cards */}
      <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 space-y-10 flex flex-col">
        <div className="flex gap-4 overflow-x-auto">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="h-80 w-80 flex-shrink-0 bg-gray-200 rounded-2xl animate-pulse"
            ></div>
          ))}
        </div>
      </div>
    </>
  );
}
const HomePage = () => {
  const { t } = useTranslation();
  const [cityId, setCityId] = useState([]);
  const [categoryId, setCategoryId] = useState();
  const [cities, setCities] = useState([]);
  const [listings, setListings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [terminalView, setTerminalView] = useState(false);
  const [isGridView, setIsGridView] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  const terminalViewParam = queryParams.get("terminalView");
  const [locationPopup, setLocationPopup] = useState(null);
  const [locationSuccess, setLocationSuccess] = useState(null);
  const [success, setSuccess] = useState(null);
  const [curretUser, setCurrentUser] = useState();
  const isTerminalScreenEnvEnabled =
    process.env.REACT_APP_ENABLE_TERMINALSCREEN === "True";

  const isTerminalScreenEnabled = isTerminalScreenEnvEnabled && terminalViewParam === "true";

  const toggleView = () => {
    setIsGridView((prev) => !prev);
  };
  async function handleSucess(value) {
    setSuccess(value);
    setTimeout(() => {
      setSuccess(null);
    }, 2000);
  }

  const navigate = useNavigate();
  const navigateTo = (path) => {
    if (path) {
      navigate(path);
    }
  };

  function goBack() {
    navigateTo(`/`);
  }

  const getCategoryNameById = (id) => {
    const catObj = categories.find((c) => c.id === id);
    return catObj ? catObj.name : "";
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  useEffect(() => {
    const checkPrivacyPolicy = () => {
      const cookieVal = getCookie("privacyPolicyAcceptedGlobally");

      try {
        const parsed = JSON.parse(decodeURIComponent(cookieVal));
        if (parsed?.accepted === true) {
          setShowPopup(false);
        } else {
          setShowPopup(true);
        }
      } catch (err) {
        console.error("Invalid cookie format:", err);
        setShowPopup(true);
      }
    };

    checkPrivacyPolicy();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setTerminalView(isTerminalScreenEnabled);
    setCities([])
    if (!curretUser) return
    getCities((locationSuccess) ? { "latitude": locationSuccess?.lat, "longitude": locationSuccess?.lon } : { "latitude": curretUser?.latitude, "longitude": curretUser?.longitude })
      .then((citiesResponse) => {
        if (Array.isArray(citiesResponse?.data?.data)) {
          setCities(citiesResponse.data.data);
        } else {
          setCities([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
        setCities([]);
      });

    const cityParam = parseInt(queryParams.get("cityId"));
    if (cityParam) {
      localStorage.setItem("cityId", cityParam);
      setCityId(cityParam);
    }
    const catParam = parseInt(queryParams.get("categoryId"));
    if (catParam) {
      setCategoryId(catParam);
    }

    getCategory()
      .then((response) => {
        const allCats = response?.data?.data || [];
        const filteredCats = allCats.filter((cat) => !hiddenCategories.includes(cat.id));
        setCategories(filteredCats);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setCategories([]);
      });

    document.title = process.env.REACT_APP_REGION_NAME;
  }, [locationSuccess, curretUser]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (parseInt(categoryId)) {
      urlParams.set("categoryId", categoryId);
    } else {
      urlParams.delete("categoryId");
    }

    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({}, "", newUrl);

    fetchData();
  }, [cityId, categoryId, searchQuery]);

  const fetchData = async (locationParams = {}) => {
    try {
      setIsLoading(true);

      const accessToken =
        window.localStorage.getItem("accessToken") ||
        window.sessionStorage.getItem("accessToken");

      let userId =
        window.localStorage.getItem("userId") ||
        window.sessionStorage.getItem("userId");

      if (!userId && accessToken) {
        try {
          const res = await getCurrentUser();
          setCurrentUser(res?.data)
          userId = res?.data?.id;
          if (userId) {
            localStorage.setItem("userId", userId);
          }
        } catch (error) {
          console.warn("User fetch failed, using public listings instead.");
        }
      }

      const params = {
        pageSize: 12,
        statusId: 1,
        pageNo: 1,
        ...locationParams,
      };

      const normalizedCityId = Array.isArray(cityId) ? cityId : [cityId];
      if (normalizedCityId[0]) {
        params.cityIds = normalizedCityId.join(",");
      }

      if (categoryId) {
        params.categoryId = String(categoryId);
      }

      if (searchQuery.trim().length > 0) {
        params.searchQuery = searchQuery.trim();
      }

      let response;

      if (userId) {
        response = await getPreferredListings(userId, params);
      } else {
        response = await getListings(params);
      }
      setListings(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching listings:", error);
      setListings([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  const clearSearchResults = () => {
    setListings([]);
    setSearchQuery("");
  };

  const getTheListings = (newCategoryId, event) => {
    event.preventDefault();
    setCategoryId(newCategoryId);
    clearSearchResults();
  };

  const handleSearch = (searchTerm) => {
    setSearchQuery(searchTerm);
  };

  window.scrollTo(0, sessionStorage.getItem("scrollPosition") || 0);
  window.addEventListener("beforeunload", () => {
    sessionStorage.setItem("scrollPosition", window.scrollY);
  });

  const goToCitizensPage = () => {
    let navUrl = "/CitizenService";
    if (cityId) {
      navUrl = `/CitizenService?cityId=${cityId}`;
    }
    navigateTo(navUrl);
  };

  const getCategoryImage = (catId) => {
    const catObj = categories.find((c) => c.id === catId);
    return catObj?.metadata?.logo || CITYIMAGE;
  };

  const scrollContainer = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  useEffect(() => {
    const updateScrollability = () => {
      const width = window.innerWidth;
      let threshold = 4;

      if (width < 768) {
        threshold = 2; // small
      } else if (width >= 768 && width < 1024) {
        threshold = 3; // medium
      }

      setIsScrollable(cities.length >= threshold);
    };

    updateScrollability();

    window.addEventListener("resize", updateScrollability);
    return () => window.removeEventListener("resize", updateScrollability);
  }, [cities]);

  const scrollLeft = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <section className="text-gray-900 body-font relative">
      <HomePageNavBar user={curretUser} setUser={setCurrentUser} />
      {success && <div className="top-14 z-50 fixed right-2 p-3 bg-green-100 text-green-800 rounded-md text-xs">{success}</div>}
      {showPopup && <PrivacyPolicyPopup />}

      <div className="container-fluid py-0 mr-0 ml-0 mt-0 w-full flex flex-col relative">
        <div className="w-full mr-0 ml-0">
          <div className="h-[40rem] lg:h-full overflow-hidden px-0 py-0 relative">
            <div className="relative h-[40rem]">
              <img
                alt="ecommerce"
                className="object-cover object-center h-full w-full"
                src={getCategoryImage(categoryId)}
                loading="lazy"
              />

              <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center bg-gray-800 bg-opacity-75 text-white z--1">
                <div className="flex flex-col xl:flex-row md:items-center justify-between gap-4 mt-4 px-5 md:px-10 lg:px-[10rem] 2xl:px-[20rem]">
                  <h1
                    className="font-sans mb-8 lg:mb-12 text-4xl md:text-5xl lg:text-5xl font-bold tracking-wide"
                    style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                  >
                    {t("homePageHeading")}
                  </h1>

                  <div className="mb-8 lg:mb-12 w-full">
                    <LocationBar onSearch={handleSearch} searchQuery={searchQuery} refreshListings={fetchData} terminalView={terminalView} setLocationPopup={setLocationPopup} citisList={cities} setLocationSuccess={setLocationSuccess} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0">
          <MostPopularCategories
            categories={categories}
            t={t}
            getTheListings={getTheListings}
          />
        </div>
      </div>

      {isLoading ? (
        <ListingsPageSkeleton />
      ) : (
        <>
          <div
            className="text-gray-900 px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 text-xl md:text-3xl mt-10 lg:text-3xl title-font text-start font-sans font-bold flex justify-between items-center"
            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
          >
            <h2>
              {categoryId
                ? t(getCategoryNameById(categoryId))
                : t("allCategories")}
            </h2>

            {/* Toggle view (grid vs feed) */}
            <svg
              className="h-6 w-6 fill-current text-gray-900 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              onClick={toggleView}
            >
              <path d="M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z" />
            </svg>
          </div>
          {locationPopup && <LocationNotFoundPopUp location={locationPopup} setIsOpen={setLocationPopup} handleSucess={handleSucess} />}
          {listings && listings.length > 0 ? (
            <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-0 space-y-10 flex flex-col">
              {isGridView ? (
                <div className="relative place-items-center bg-white mb-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 justify-start">
                  {listings.map((listing, index) => (
                    <ListingsCard
                      listing={listing}
                      terminalView={terminalView}
                      key={index}
                    />
                  ))}
                </div>
              ) : (
                <div className="columns-1 md:columns-2 gap-4">
                  {listings.map((listing, index) => (
                    <div
                      key={index}
                      className={`break-inside-avoid ${index % 2 === 1 ? "mt-6" : ""}`}
                    >
                      <ListingsFeed listing={listing} terminalView={terminalView} />
                    </div>
                  ))}
                </div>
              )}

              <button
                className="mt-10 px-6 py-3 bg-gray-700 w-80 text-white rounded-full hover:scale-105 transition mx-auto"
                onClick={() => {
                  localStorage.setItem("selectedItem", t("chooseOneCategory"));
                  const url = "/AllListings";
                  navigateTo(url);
                }}
              >
                {t("loadMore")}
              </button>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center min-h-[40vh] px-6">
              <h2 className="mb-6 text-4xl font-bold">
                {t("currently_no_listings")}
              </h2>
              <p className="text-lg text-gray-600">
                {t("selectOtherCityorCategory")}
              </p>
              <button
                onClick={goBack}
                className="mt-10 px-6 py-3 bg-gray-700 text-white rounded-full hover:scale-105 transition"
              >
                {t("goBack")}
              </button>
            </div>
          )}

          <h2
            className="text-gray-900 px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 text-xl md:text-3xl mt-10 lg:text-3xl title-font text-start font-sans font-bold"
            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
          >
            {t("discoverMorePlaces")}
          </h2>

          <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-0 space-y-10 flex flex-col items-center">
            <div className="flex items-center w-full relative">
              {isScrollable && (
                <button
                  onClick={scrollLeft}
                  className="absolute hidden md:flex left-0 z-10 p-2 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg bg-gray-900 border-4 border-white"
                >
                  ❮
                </button>
              )}

              <div
                ref={scrollContainer}
                className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth w-full"
                style={{ scrollSnapType: "x mandatory", whiteSpace: "nowrap" }}
              >
                {cities.map((city) => {
                  if (city.id !== Number(cityId)) {
                    return (
                      <div
                        key={city.id}
                        onClick={() => {
                          const scrollPosition = window.scrollY;
                          localStorage.setItem("selectedCity", city.name);
                          navigateTo(`/AllListings?cityId=${city.id}`);
                          window.addEventListener("popstate", function () {
                            window.scrollTo(0, scrollPosition);
                          });
                        }}
                        className="h-80 w-80 rounded-2xl cursor-pointer transition-transform duration-500 shadow-[0_3px_10px_rgb(0,0,0,0.2)] hover:scale-90 flex-shrink-0"
                        style={{ scrollSnapAlign: "start" }}
                      >
                        <div className="relative h-80 rounded-2xl overflow-hidden">
                          <img
                            alt="ecommerce"
                            className="object-cover object-center rounded-lg h-full w-full"
                            src={
                              city.image
                                ? city.image
                                : CITYIMAGE
                            }
                            onError={(e) => {
                              e.target.src = CITYDEFAULTIMAGE;
                            }}
                          />
                          <div
                            className="absolute inset-0 flex flex-col justify-end text-white"
                            style={{
                              background:
                                "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
                            }}
                          >
                            <h1
                              className="text-xl pb-5 md:text-3xl font-sans font-bold mb-0 ml-4"
                              style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                            >
                              {city.name}
                            </h1>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>

              {isScrollable && (
                <button
                  onClick={scrollRight}
                  className="absolute hidden md:flex right-0 z-10 p-2 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg bg-gray-900 border-4 border-white"
                >
                  ❯
                </button>
              )}
            </div>
          </div>

          <h2
            className="text-gray-900 px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 text-xl md:text-3xl mt-10 lg:text-3xl title-font text-start font-sans font-bold"
            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
          >
            {t("allCategories")}
          </h2>

          <div >
            <AllCategoriesTiles
              categories={categories}
              scrollContainer={scrollContainer}
              t={t}
              getTheListings={getTheListings}
            />
          </div>

          <div
            className={`mx-auto px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 flex justify-center lg:h-[28rem] sm:h-[35rem] ${RegionColors.lightBgColorV2}`}
          >
            <div className="flex flex-wrap items-center">
              <div className="w-full md:w-1/2 px-4">
                <h2
                  className="text-4xl text-white font-bold mb-4 font-sans"
                  style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                >
                  {t("citizenService")}
                </h2>
                <p
                  className="mb-4 text-gray-900 text-lg font-bold font-sans"
                  style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                >
                  {t("findBestCitizenServicesInTheCity")}
                </p>

                <a
                  onClick={() => goToCitizensPage()}
                  className={`flex items-center ${RegionColors.darkTextColorV2} border ${RegionColors.darkBorderColorV2} py-2 px-6 gap-2 rounded inline-flex items-center cursor-pointer`}
                  style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                >
                  <span>{t("clickHereToFind")}</span>
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="w-6 h-6 ml-2"
                  >
                    <path d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </a>
              </div>

              <div className="w-full md:w-1/2 flex flex-wrap lg:mt-0 md:mt-6 mt-6">
                <img
                  src={process.env.REACT_APP_BUCKET_HOST + "admin/CitizenService2.png"}
                  alt="Image 1"
                  className="w-full md:w-98 mb-2"
                />
              </div>
            </div>
          </div>

          <div
            className={`${RegionColors.darkBgColorV2} px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 flex justify-start`}
          >
            <style>
              {`
                    @media (max-width: 280px) {
                      .galaxy-fold {
                        flex-direction: column;
                      }
                    }
                  `}
            </style>
            <div className="flex flex-col md:flex-row place-items-center justify-start">
              <p
                className="flex mt-4 px-4 py-2 text-white items-center cursor-pointer text-lg font-bold font-sans"
                style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
              >
                {t("downloadUs")}
              </p>
              <div className="flex mt-4 px-4 py-2 md:gap-4 gap-4 items-center cursor-pointer galaxy-fold">
                {/* iOS */}
                <div
                  className="flex mt-0 w-36 h-10 bg-white text-black rounded-lg items-center justify-center transition duration-300 transform hover:scale-105"
                  onClick={() => {
                    // Adjust your store link as needed
                    window.location.href = process.env.REACT_APP_APPLESTORE;
                  }}
                >
                  <div className="mr-2">
                    <svg viewBox="0 0 384 512" width="20">
                      <path
                        fill="currentColor"
                        d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                      />
                    </svg>
                  </div>
                  <div className="block">
                    <div className="text-xs">{t("downloadOnThe")}</div>
                    <div className="-mt-1 font-sans text-sm font-semibold">
                      {t("appStore")}
                    </div>
                  </div>
                </div>

                {/* Android */}
                <div
                  className="flex mt-0 w-36 h-10 bg-white text-black rounded-lg items-center justify-center transition duration-300 transform hover:scale-105"
                  onClick={() => {
                    // Adjust your store link as needed
                    window.location.href = process.env.REACT_APP_GOOGLEPLAYSTORE;
                  }}
                >
                  <div className="mr-2">
                    <svg viewBox="30 336.7 120.9 129.2" width="20">
                      <path
                        fill="#FFD400"
                        d="M119.2,421.2c15.3-8.4,27-14.8,28-15.3c3.2-1.7,6.5-6.2,0-9.7  c-2.1-1.1-13.4-7.3-28-15.3l-20.1,20.2L119.2,421.2z"
                      />
                      <path
                        fill="#FF3333"
                        d="M99.1,401.1l-64.2,64.7c1.5,0.2,3.2-0.2,5.2-1.3  c4.2-2.3,48.8-26.7,79.1-43.3L99.1,401.1L99.1,401.1z"
                      />
                      <path
                        fill="#48FF48"
                        d="M99.1,401.1l20.1-20.2c0,0-74.6-40.7-79.1-43.1  c-1.7-1-3.6-1.3-5.3-1L99.1,401.1z"
                      />
                      <path
                        fill="#3BCCFF"
                        d="M99.1,401.1l-64.3-64.3c-2.6,0.6-4.8,2.9-4.8,7.6  c0,7.5,0,107.5,0,113.8c0,4.3,1.7,7.4,4.9,7.7L99.1,401.1z"
                      />
                    </svg>
                  </div>
                  <div className="block">
                    <div className="text-xs">{t("getItOn")}</div>
                    <div className="-mt-1 font-sans text-sm font-semibold">
                      {t("googlePlay")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )
      }

      {
        !isLoading && (
          <div className="bottom-0 w-full">
            <Footer />
          </div>
        )
      }
    </section >
  );
};

export default HomePage;